import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { OrderHistoryService } from '../order-history.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LoginComponent } from '../../login/login.component';

@Component({
  selector: 'app-update-order-status',
  templateUrl: './update-order-status.component.html',
  styleUrls: ['./update-order-status.component.scss'],
})
export class UpdateOrderStatusComponent implements OnInit {
  ordernumber: string | null = '';
  selectedstatus: number = 0;
  orderobject: any;
  isDisabled: boolean = false;
  orderStatus: number=0;
  Remarks: string;
  constructor(
    public service: OrderHistoryService,
    private cdr: ChangeDetectorRef,
    private dialogRef: MatDialogRef<UpdateOrderStatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { ordernumber: string, orderstatus: number },
    private toastr: ToastrService
  ) {}
  ngOnInit(): void {
    this.ordernumber = localStorage.getItem('orderNumberStatus');
    this.orderStatus=this.data.orderstatus; 
    this.getOldStatusbyorderId();
    console.log('Statussss', this.orderStatus);
  }

  updateStatus() {
    this.orderobject.orderStatus = this.selectedstatus;
    this.orderobject.remarks=this.Remarks;
    this.service.UpdateStatus(this.orderobject).subscribe({
      next: (r) => {
        this.toastr.success('Status has been Updated Successfully', 'Success');
        this.dialogRef.close({ refresh: true });
        this.isDisabled = true;
      },
      error: (e) => {
        if (e.error.message) {
          this.toastr.error('Oops!', e.error.message);
        } else {
          this.toastr.error('Oops!', 'Something went wrong');
        }
        this.dialogRef.close({ refresh: true });
        this.isDisabled = true;
      },
    });
  }

  onStatusChange(event: Event): void {
    const newValue = parseInt((event.target as HTMLSelectElement).value, 10);
    this.selectedstatus = newValue; // Ensure that the selectedstatus is updated correctly
  }
  getOldStatusbyorderId() {
    this.service
      .getoldStatusbyOrderId(this.ordernumber)
      .subscribe((res: any) => {
        this.ordernumber = res.orderNumber;
        this.selectedstatus = res.orderStatus;
        this.orderobject = res;
        console.log(res);
      });
  }
  closeDialog() {
    this.dialogRef.close({ refresh: true });
  }

  isUpdatableStatus(status: number): boolean {
    // Allow updates only for Pending (4) and Processing (1)
    return status === 3 || status ===4 || status === 5 ;

  }

}
